import { Routes } from '@angular/router';
import { AuthenticationGuardService } from './auth/guards/authentication-guard';
import { EmployeeDevelopmentObjectivesComponent } from './modules/development-objectives/components/employee-development-objectives/employee-development-objectives.component';
import { EmployeePerformanceObjectivesComponent } from './modules/performance-objectives/components/employee-performance-objectives/employee-performance-objectives.component';
import { ClassicSandboxComponent } from './shared/iframe/components/classic-sandbox/classic-sandbox.component';

export const classicRoutes: Routes = [
  {
    path: '',
    children: [
      {
        path: 'recruitment-job-detail',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath:
            '/perfnav/recruitment/homepage/viewjobdetail.asp?item={jobopeningid}',
        },
      },
      {
        path: 'recruitment-my-applications',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath:
            '/perfnav/recruitment/ML/common/jobAgent/viewJobAgentGeneral.asp',
        },
      },
      {
        path: 'absence-management',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/adm/timeline.asp?DOTNET=1',
        },
      },
      {
        path: 'goals-and-performance',
        component: EmployeeDevelopmentObjectivesComponent,
        data: {
          showLayout: true,
          //classicpath: '/perfnav/student/ML/common/performance/viewperformancedetaildevelopmentobjectives.asp?DOTNET=1',
          // classicPath: '/reviews/objectives/employee-development-objectives'
        },
      },
      {
        path: 'development-goals',
        component: EmployeeDevelopmentObjectivesComponent,
        data: {
          showLayout: true,
          // //classicpath: '/perfnav/student/ML/common/performance/viewperformancedetaildevelopmentobjectives.asp?DOTNET=1',
          // classicPath: '/reviews/objectives/employee-development-objectives'
        },
      },
      {
        path: 'performance-goals',
        component: EmployeePerformanceObjectivesComponent,
        data: {
          showLayout: true,
          //classicpath: '/perfnav/administration/EN/common/students/viewstudentdetailobjectives.asp?DOTNET=1&item={studentid}',
        },
      },
      {
        path: 'development',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath:
            '/perfnav/student/ML/common/schedule/viewscheduledetailgeneral.asp?DOTNET=1',
        },
      },
      {
        path: 'my-courses',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath:
            '/perfnav/student/ML/common/schedule/viewscheduledetailgeneral.asp?DOTNET=1',
        },
      },
      {
        path: 'courses-active',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath:
            '/perfnav/student/ML/common/schedule/viewscheduledetailgeneral.asp?DOTNET=1',
        },
      },
      {
        path: 'course-requests',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath:
            '/perfnav/student/ML/common/schedule/viewcourserequestsdetailgeneral.asp?DOTNET=1',
        },
      },
      {
        path: 'courses-finished',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath:
            '/perfnav/student/ML/common/history/viewhistorydetailgeneral.asp?DOTNET=1',
        },
      },
      {
        path: 'learningpaths',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath: '/perfnav/administration/en/adm/timeline.asp?DOTNET=1',
        },
      },
      {
        path: 'conversations',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath:
            '/perfnav/student/ML/common/performance/viewperformancedetailhistory.asp?DOTNET=1',
        },
      },
      {
        path: 'informal-conversations',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath:
            '/perfnav/student/ML/common/performance/viewgeneralcomment.asp?actor=self&revStatus=0&DOTNET=1',
        },
      },
      {
        path: 'my-informal-conversations',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath:
            '/perfnav/student/ML/common/performance/viewgeneralcomment.asp?actor=self&revStatus=0&DOTNET=1',
        },
      },
      {
        path: 'add-informal-conversation',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath:
            '/perfnav/student/ML/common/performance/addgeneralcomment.asp?from=view&actor=self&item={studentid}&DOTNET=1',
        },
      },
      {
        path: 'peer-informal-conversations',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath:
            '/perfnav/student/ML/common/performance/viewgeneralcomment.asp?actor=peer&revStatus=0&DOTNET=1',
        },
      },
      {
        path: 'formal-conversations',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath:
            '/perfnav/student/ML/common/performance/viewperformancedetailhistory.asp?DOTNET=1',
        },
      },
      {
        path: 'ad-hoc-conversations',
        // redirectTo: '/framework/extrafieldtabs',
        // pathMatch: 'full'
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath:
            '/perfnav/administration/EN/common/students/viewAdHocConversations.asp?indirrep=&DOTNET=1&item={studentid}',
        },
      },
      {
        path: 'career-start',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath:
            '/perfnav/student/ML/common/careermanagement/careerstart.asp?item={studentid}&DOTNET=1',
        },
      },
      {
        path: 'career-education',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath:
            '/perfnav/student/ML/common/careermanagement/education.asp?item={studentid}&DOTNET=1',
        },
      },
      {
        path: 'career-knowledge',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath:
            '/perfnav/student/ML/common/careermanagement/knowledge.asp?item={studentid}&DOTNET=1',
        },
      },
      {
        path: 'career-career',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath:
            '/perfnav/student/ML/common/careermanagement/career.asp?item={studentid}&DOTNET=1',
        },
      },
      {
        path: 'career-career2',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath:
            '/perfnav/student/ML/common/careermanagement/careerperspectives.asp?item={studentid}&DOTNET=1',
        },
      },
      {
        path: 'library',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath:
            '/perfnav/student/ML/common/library/librarycatalog.asp?DOTNET=1',
        },
      },
      {
        path: 'function-catalog',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath:
            '/perfnav/student/ML/common/catalog/viewfunctioncatalog.asp?DOTNET=1',
        },
      },
      {
        path: 'who-is-who',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath:
            '/perfnav/student/ML/common/directory/searchresults.asp?DOTNET=1',
        },
      },
      {
        path: 'organogram',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath:
            '/perfnav/administration/en/common/organogram/positionsorganogram.asp?DOTNET=1',
        },
      },
      {
        path: 'my-profile',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath:
            /*'/perfnav/student/ML/common/students/viewstudentdetailgeneral.asp?DOTNET=1&item={studentid}',*/
            '/perfnav/student/ML/common/info/myinfo.asp?DOTNET=1',
        },
      },
      {
        path: 'my-qualifications',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath:
            '/perfnav/administration/en/common/students/viewstudentdetailcertificates.asp?from=1&indirrep=0&DOTNET=1&openreq=1',
        },
      },
      {
        path: 'qualifications-responsible',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath:
            '/perfnav/administration/en/common/certificates/certificatedetail.asp?DOTNET=1&viewdetail=0',
        },
      },
      {
        path: 'talent-forum',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath:
            '/perfnav/student/ML/common/socialmedia/messageboard.asp?indirrep=0&DOTNET=1',
        },
      },

      // TRAINER PAGES
      {
        path: 'course-planning',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath:
            '/perfnav/trainer/EN/common/trainers/viewtrainerdetailschedule.asp?indirrep=0&DOTNET=1',
        },
      },
      {
        path: 'course-history',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath:
            '/perfnav/trainer/EN/common/trainers/viewtrainerdetailhistory.asp?indirrep=0&DOTNET=1',
        },
      },
      {
        path: 'my-performance',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath:
            '/perfnav/trainer/EN/common/trainers/viewtrainerdetailcourses.asp?indirrep=0&DOTNET=1',
        },
      },
      {
        path: 'timeline',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath:
            '/perfnav/administration/en/adm/timeline.asp?indirrep=0&DOTNET=1',
          // &netfilter=' + localStorage.getItem('manager_view') //geen parameter hier werk niet in productie
        },
      },
      {
        path: 'NCC-detail',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath:
            '/perfnav/administration/en/common/waitlist/ncc.asp?from=list&DOTNET=1&iscreate=1&fromstu=1',
          // &request="&Server.URLEncode(rsCourseEvents("CourseRegistrationRequest-ID"))&"&amp;student="&Server.URLEncode(studID)&"')"%>
          // andere parameter toegevoegd on click
        },
      },
      {
        path: 'CC-detail',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath:
            '/perfnav/administration/en/common/students/viewcourseeventparticipantdetail.asp?DOTNET=1',
          // ?item="&Server.URLEncode(rsCourseEvents("CourseEventParticipant-ID"))
          // &"&event="&Server.URLEncode(rsCourseEvents("CourseEvent-ID"))&"')"%>
          // andere parameter toegevoegd on click
        },
      },
      {
        path: 'E-learning-detail',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath:
            '/perfnav/student/ML/common/schedule/elearninghistorydetail.asp?DOTNET=1',
          // ??item="&Server.URLEncode(rsCourseEvents("CourseEventParticipant-ID"))&""%>  andere parameter toegevoegd on click
        },
      },
      {
        path: 'connectionmessageboard',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath:
            '/perfnav/student/ML/common/socialmedia/messageboard.asp?DOTNET=1',
          // ??item="&Server.URLEncode(rsCourseEvents("CourseEventParticipant-ID"))&""%>  andere parameter toegevoegd on click
        },
      },
      {
        path: 'connectionprofile',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath:
            '/perfnav/student/ML/common/socialmedia/profile.asp?DOTNET=1',
          // ??item="&Server.URLEncode(rsCourseEvents("CourseEventParticipant-ID"))&""%>  andere parameter toegevoegd on click
        },
      },

      {
        path: 'knowledge-domains',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath:
            '/perfnav/administration/en/common/students/viewstudentdetailcompetenciestech.asp?indirrep=0&DOTNET=1',
        },
      },
      {
        path: 'knowledge-domains-reports',
        component: ClassicSandboxComponent,
        data: {
          showLayout: true,
          classicpath:
            '/perfnav/administration/EN/common/competencies/exportclusters.asp?indirrep=0&DOTNET=1',
        },
      },
    ],

    canActivate: [AuthenticationGuardService],
  },
];
